module.exports = "<p>Please wait while we redirect you back</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth-callback/auth-callback.component.html
// module id = ./src/app/auth-callback/auth-callback.component.html
// module chunks = main